import { OpenType, ProductSelectType } from '../../utils';
export function seoConfig() {
  return {
    // PDF预览页面
    pdfSeo: {
      [OpenType.policyDetail]: {
        title: 'seo.policy_service_detail_seo_title',
        keywords: 'seo.policy_service_detail_seo_keywords',
        desc: 'seo.policy_service_detail_seo_desc'
      },
      [OpenType.instructions]: {
        title: 'seo.instructions_detail_seo_title',
        keywords: 'seo.instructions_detail_seo_keywords',
        desc: 'seo.instructions_detail_seo_desc'
      }
    },
    // 选品页面
    productSelectSeo: {
      [ProductSelectType.selfInspectManual]: {
        title: 'seo.product_select_faq_seo_title',
        keywords: 'seo.product_select_faq_seo_keywords',
        desc: 'seo.product_select_faq_seo_desc'
      },
      [ProductSelectType.vehicleSupport]: {
        title: 'seo.product_select_vehicle_seo_title',
        keywords: 'seo.product_select_vehicle_seo_keywords',
        desc: 'seo.product_select_vehicle_seo_desc'
      },
      [ProductSelectType.selfRepair]: {
        title: 'seo.product_select_self_repair_seo_title',
        keywords: 'seo.product_select_self_repair_seo_keywords',
        desc: 'seo.product_select_self_repair_seo_desc'
      },
      [ProductSelectType.instructions]: {
        title: 'seo.product_select_instruction_seo_title',
        keywords: 'seo.product_select_instruction_seo_keywords',
        desc: 'seo.product_select_instruction_seo_desc'
      },
      [ProductSelectType.policyDetail]: {
        title: 'seo.product_select_policy_service_seo_title',
        keywords: 'seo.product_select_policy_service_seo_keywords',
        desc: 'seo.product_select_policy_service_seo_desc'
      }
    }
  };
}
